import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";
import { selectMyTeamsIds } from "../../auth/selectors";

const selectEntities = (state: RootState) => state.data.trailers.entities;
const selectIds = (state: RootState) => state.data.trailers.ids;

export const selectVehicles = createSelector(
  selectIds,
  selectEntities,
  (ids, entities) => ids.map((id) => entities[id])
);

export const selectTrucks = createSelector(selectVehicles, (vehicles) =>
  vehicles.filter((vehicle) => vehicle.powered)
);

export const selectTrailers = createSelector(selectVehicles, (vehicles) =>
  vehicles.filter((vehicle) => !vehicle.powered)
);

export const selectVehiclesVisibleToUser = createSelector(
  selectVehicles,
  selectMyTeamsIds,
  (trailers, myTeams) =>
    trailers.filter((trailer) =>
      trailer.teams.some((teamId) => myTeams.includes(teamId))
    )
);

export const selectVehiclesForTeams = (teamsIds: string[]) =>
  createSelector(selectVehicles, (trailers) =>
    trailers.filter((t) => t.teams.some((tId) => teamsIds.includes(tId)))
  );

export const selectVehicle = (id?: string | null) => (state: RootState) =>
  !id ? undefined : state.data.trailers.entities[id];

export const selectTrailerType = (id: string | null) => (state: RootState) =>
  (id && state.data.trailers.entities[id]?.type) || null;

export const selectTruckDepartmentIdForCargo =
  (cargoId: string) => (state: RootState) => {
    const route = Object.values(state.data.routeViewModels.entities).find(
      (route) => route && route.cargoOrder.includes(cargoId)
    );
    if (!route || !route.truckId) {
      return null;
    }
    return state.data.trailers.entities[route.truckId]?.departmentId ?? null;
  };
